<template>
  <div class="customer-notice">
    <h2 class="title">客户告知书</h2>

    <p class="greeting">尊敬的客户：</p>

    <p class="paragraph">
      感谢选择我公司为您提供保险经纪服务。我公司是基于投保人的利益，为投保人与保险公司订立保险合同提供中介服务，并依法收取佣金的保险经纪机构。按照《保险经纪人监管规定》、《互联网保险业务监管办法》要求，我公司应履行客户告知义务，现将相关事项告知如下：
    </p>

    <div class="content">
      <p>
        <strong>一、</strong> 公司名称：天津华盛保险经纪有限公司住所：天津自贸试验区（中心商务区）旷世国际大厦2栋1410；许可证名称及机构编码：《保险中介许可证》
        260942000000800；批准日期：2011年03月09日（有效期至：2026年3月19日）；业务范围：在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；保险监督管理机构批准的其他业务；经营区域：全国（港、澳、台除外）；联系方式：010-50822713。
      </p>

      <p>
        <strong>二、</strong>
        根据保险监管部门的规定，只有持《保险经纪从业人员执业证书》的人员方可从事保险经纪业务，您可要求本公司业务人员出示《保险经纪从业人员执业证书》，并可通过登录中国保监会保险中介监管信息系统查询业务人员持证情况（
        <span style="color: blue;">http://iir.circ.gov.cn</span> ）。
      </p>

      <p>
        <strong>三、</strong>
        请仔细阅读保险条款，保险产品的广告、公告、彩页等宣传资料不属于保险合同的组成部分。请重点关注保险责任、责任免除或者除外责任、犹豫期后解除合同的损失、投保人和被保险人权利义务、免赔额或免赔率的计算、等待期等内容，并可要求本公司服务人员对上述内容进行详细讲解。
      </p>

      <p>
        <strong>四、</strong>
        请向本公司客服人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄或职业不真实等情形导致的法律后果。
      </p>

      <p><strong>五、</strong> 根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。</p>

      <p><strong>五、</strong> 本公司已按《保险经纪人监管规定》缴存保证金/投保职业责任保险。</p>

      <p><strong>六、</strong> 本公司为您与保险公司订立保险合同提供保险经纪服务，并依据与保险公司签订的协议依法收取经纪费。</p>

      <p><strong>七、</strong> 本公司及公司高级管理人员与经纪业务相关的保险公司、其它中介机构不存在关联关系。</p>

      <p><strong>八、</strong> 如果您发现本公司服务人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司投诉。</p>

      <p><strong>九、</strong> 纠纷解决联系方式：</p>

      <p class="indent">公司客服电话：400-000-7535</p>
      <p class="indent">公司投诉电话：010-50822713</p>
      <p class="indent">中国银行保险监督管理委员会消费者投诉维权电话：12378</p>

      <p><strong>十、</strong> 投保人义务确认</p>

      <p class="indent">
        您已按照您投保的保险产品要求进行如实告知，如出现因未如实告知情况发生的任何违反《中华人民共和国保险法》第十六条法规的，投保人自行承担违反义务的后果。投保人已阅知如下的第十六条法规内容，并承诺已如实告知。
      </p>

      <p class="law-article">
        《中华人民共和国保险法》第十六条订立保险合同，保险人就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除合同。前款规定的合同解除权，自保险人知道有解除事由之日起，超过三十日不行使而消灭。自合同成立之日起超过二年的，保险人不得解除合同；发生保险事故的，保险人应当承担赔偿或者给付保险金的责任。投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担赔偿或者给付保险金的责任，并不退还保险费。投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担赔偿或者给付保险金的责任，但应当退还保险费。保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应当承担赔偿或者给付保险金的责任。保险事故是指保险合同约定的保险责任范围内的事故。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerNotice",
  data() {
    return {
      // 可以在这里添加需要的数据
    };
  },
};
</script>

<style scoped>
.customer-notice {
  font-family: "SimSun", "宋体", serif;
  font-size: 4.8vw;
  color: #000;
  line-height: 1.5;
  padding: 5.6vw;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: left;
}

.title {
  font-size: 5.6vw;;
  font-weight: bold;
  text-align: center;
  margin-bottom: 5.6vw;;
}

.greeting {
  text-indent: 0;
  text-align: left;
  margin-bottom: 3.8vw;
}

.paragraph {
  text-indent: 2em;
  margin-bottom: 3.8vw;
}

.content {
  margin-top: 4.8vw;;
}

.content p {
  margin-bottom: 3.2vw;
  text-indent: 0;
}

.law-article {
  color: red;
  font-size: 4.8vw;;
  line-height: 1.6;
}

strong {
  font-weight: 900;
}

a {
  color: #06c;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
